import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';

@Component({
  selector: 'app-logout-success',
  templateUrl: './logout-success.component.html',
  styleUrls: ['./logout-success.component.scss'],
})
export class LogoutSuccessComponent implements OnInit {
  requestId!: string;
  buttonOptions: any = {
    backToLogin: {
      color: 'accent',
      text: 'BACK_TO_LOGIN',
      alignment: 'right',
      type: 'proceed',
      underline: 'none'
    }
  }
  constructor(private route: ActivatedRoute, public commonFunc: CommonFunctionsService) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.requestId = params.requestId || null;
    });
  }
}
